import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { RestService } from '../rest.service';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-directory-setup-modal',
  templateUrl: './directory-setup-modal.component.html',
  styleUrls: ['./directory-setup-modal.component.css']
})
export class DirectorySetupModalComponent implements OnInit {

  activeDictorySelected: boolean = true;
  oktaSelected: boolean = false;

  url: any = "";
  basedn: any = "";
  username: any = "";
  password: any = "";
  isUrlEmpty: boolean = false;
  isBasednEmpty: boolean = false;
  isUsernameEmpty: boolean = false;
  isPasswordEmpty: boolean = false;

  oktaorgurl: any = "";
  oktatoken: any = "";
  isOktaorgurlEmpty: boolean = false;
  isOktatokenEmpty: boolean = false;

  isADFailure: boolean = false;
  adFailureMessage: any = "";
  isOktaFailure: boolean = false;
  oktaFailureMessage: any = "";

  @Output() close = new EventEmitter<any>();

  constructor(private _restService: RestService) { }

  ngOnInit() {
    
  }

  cancelActiveDirectoryModal(){
    this.close.emit();
  }

  activeDirectoryEvent(e: any) {
    this.isUrlEmpty = false;
    this.isBasednEmpty = false;
    this.isUsernameEmpty = false;
    this.isPasswordEmpty = false;
    this.isOktatokenEmpty = false;
    this.isOktaorgurlEmpty = false;
    this.url = "";
    this.basedn = "";
    this.username = "";
    this.password = "";
    this.oktaorgurl = "";
    this.oktatoken = "";

    e.target.checked === true
      ? ((this.activeDictorySelected = true), (this.oktaSelected = false))
      : (this.activeDictorySelected = false);
  }

  oktaEvent(e: any) {
    this.isUrlEmpty = false;
    this.isBasednEmpty = false;
    this.isUsernameEmpty = false;
    this.isPasswordEmpty = false;
    this.isOktatokenEmpty = false;
    this.isOktaorgurlEmpty = false;
    this.url = "";
    this.basedn = "";
    this.username = "";
    this.password = "";
    this.oktaorgurl = "";
    this.oktatoken = "";

    e.target.checked === true
      ? ((this.oktaSelected = true), (this.activeDictorySelected = false))
      : (this.oktaSelected = false);
  }

  onChangeUrl(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.url = ""), (this.isUrlEmpty = true))
      : (this.isUrlEmpty = false);
  }

  onChangeBasedn(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""), (this.basedn = ""), (this.isBasednEmpty = true))
      : (this.isBasednEmpty = false);
  }

  onChangeUsername(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.username = ""),
        (this.isUsernameEmpty = true))
      : (this.isUsernameEmpty = false);
  }

  onChangePassword(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.password = ""),
        (this.isPasswordEmpty = true))
      : (this.isPasswordEmpty = false);
  }

  onChangeOktaorgurl(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.oktaorgurl = ""),
        (this.isOktaorgurlEmpty = true))
      : (this.isOktaorgurlEmpty = false);
  }

  onChangeOktatoken(e: any) {
    e.target.value.substring(0, 1) === " "
      ? ((e.target.value = ""),
        (this.oktatoken = ""),
        (this.isOktatokenEmpty = true))
      : (this.isOktatokenEmpty = false);
  }



  adirAdminSetup() {
    this.url === "" ? (this.isUrlEmpty = true) : (this.isUrlEmpty = false);
    this.basedn === ""
      ? (this.isBasednEmpty = true)
      : (this.isBasednEmpty = false);
    this.username === ""
      ? (this.isUsernameEmpty = true)
      : (this.isUsernameEmpty = false);
    this.password === ""
      ? (this.isPasswordEmpty = true)
      : (this.isPasswordEmpty = false);

    if (
      this.url !== "" &&
      this.basedn !== "" &&
      this.username !== "" &&
      this.password !== ""
    ) {
      this._restService
        .checkingTypeUsers(
          2,
          null,
          null,
          this.url,
          this.basedn,
          this.username,
          this.password
        )
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isADFailure = true;
            this.adFailureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (data: any) => (
            localStorage.setItem("isSetUpInfoProvided", "1"),
            this.close.emit(true)
          )
        );
    }
  }


  oktaAdminSetup() {
    this.oktatoken === ""
      ? (this.isOktatokenEmpty = true)
      : (this.isOktatokenEmpty = false);
    this.oktaorgurl === ""
      ? (this.isOktaorgurlEmpty = true)
      : (this.isOktaorgurlEmpty = false);

    if (this.oktatoken !== "" && this.oktaorgurl !== "") {
      this._restService
        .checkingTypeUsers(
          1,
          this.oktatoken,
          this.oktaorgurl,
          null,
          null,
          null,
          null
        )
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isOktaFailure = true;
            this.oktaFailureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (data: any) => (
            localStorage.setItem("isSetUpInfoProvided", "1"),
            this.close.emit(true)
          )
        );
    }
  }

}
